const csrfTokenStore = {
    csrfToken: '',
};

export default csrfTokenStore;
